<template>
    <form id="sign-in-form" autocomplete="on" @submit.prevent="validateFields">
        <div class="row">
            <div class="col">
                <slot name="before-email-input" />
                <div class="form-group">
                    <label :class="{'text-danger': errors.has('email') }" for="email">
                        Email
                    </label>
                    <input
                        id="email"
                        v-model="email"
                        v-validate="'email|required'"
                        type="email"
                        autocomplete="on"
                        :class="{ 'is-danger': errors.has('email') }"
                        class="form-control"
                        name="email"
                    >
                    <span v-show="errors.has('email')" class="text-danger">
                        {{ errors.first('email') }}
                    </span>
                </div>
                <password-input
                    v-model="password"
                    v-validate="'required'"
                    class="mb-0"
                    name="password"
                    autocomplete="on"
                    :error="errors.first('password')"
                />
                <p v-if="forgotRoute" class="forgot-account">
                    <router-link tabindex="-1" :to="{ name: forgotRoute}">
                        Forgot password?
                    </router-link>
                </p>
                <button
                    :class="['btn',`btn-${formClass}`,'btn-block mt-4 mb-2']"
                    type="submit"
                >
                    <slot name="submit-btn-text">
                        Sign in with email
                    </slot>
                </button>
                <slot name="after-email-input" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "SignInForm",
    components: {
        passwordInput: () => import(/* webpackChunkName: "password-input"*/ "@c/password-input")
    },
    props: {
        forgotRoute: {
            type: String,
            default() {
                return "";
            }
        },
        formClass: {
            type: String,
            default() {
                return "primary";
            }
        }
    },
    data() {
        return {
            email: "",
            password: ""
        };
    },
    methods: {
        async validateFields() {
            const isValid = await this.$validator.validate();
            const userData = {
                email_address: this.email,
                password: this.password
            };
            if (isValid) {
                this.$emit("submit-data", userData);
            }
        }
    }
};
</script>
